import { initializeApp, } from 'firebase/app';
import { getFirestore, } from 'firebase/firestore';
import { getAuth, } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyAqugvQMIe57_gsGr1Lr-DLITL_0UPBMbM",
    authDomain: "cards-9ac25.firebaseapp.com",
    projectId: "cards-9ac25",
    storageBucket: "cards-9ac25.appspot.com",
    messagingSenderId: "788359698317",
    appId: "1:788359698317:web:b9d913dc6d4b2910378fc4",
};

initializeApp(firebaseConfig);

const db = getFirestore();
const auth = getAuth();

export {
    db,
    auth,
};